module.exports = __webpack_public_path__ + "static/media/structure.6874e1d0.svg";